// The small device read-outs both Foyers and Appareils use: signal bars from
// the gateway's RSSI, a battery gauge, and the 24-hour reception strip.
import { S } from '../lib/strings';

export function sigLevel(rssi: number | null, online: boolean) {
  if (!online || rssi == null) return 0;
  return rssi > -65 ? 4 : rssi > -75 ? 3 : rssi > -90 ? 2 : 1;
}

export function Sig({ rssi, online }: { rssi: number | null; online: boolean }) {
  const l = sigLevel(rssi, online);
  return <span className={'sig l' + l} aria-label={'Signal ' + S.dv.sig[l]}><i /><i /><i /><i /></span>;
}

export function Bat({ pct }: { pct: number | null }) {
  if (pct == null) return <span className="bat muted">—</span>;
  return <span className={'bat' + (pct < 20 ? ' low' : '')}><i><s style={{ width: pct + '%' }} /></i><span className="num">{pct} %</span></span>;
}

/** One cell per hour, oldest first: grey when nothing arrived that hour. */
export function Strip({ hours, online }: { hours: number[]; online: boolean }) {
  return (
    <div className="up" aria-label={S.dv.hours}>
      {hours.map((n, i) => <i key={i} className={!online || n === 0 ? 'm' : ''} />)}
    </div>
  );
}
